import { HttpInterceptorFn, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { NotificationService } from '../services/notification';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const notificationService = inject(NotificationService);
    const http = inject(HttpClient);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            let errorMessage = 'Si è verificato un errore imprevisto.';

            if (error.error instanceof ErrorEvent) {
                // Client-side error
                errorMessage = `Errore: ${error.error.message}`;
                // Log to backend
                http.post('/api/logs', {
                    message: error.error.message,
                    details: 'Client Side Error'
                }).subscribe();

            } else {
                // Server-side error
                // Don't loop by logging /api/logs errors
                if (!req.url.includes('/api/logs')) {
                    const backendError = error.error?.error || '';

                    if (backendError.includes('Invalid email domain')) {
                        errorMessage = 'Dominio email non valido';
                    } else if (error.status === 401) {
                        errorMessage = 'Sessione scaduta o non valida';
                    } else {
                        errorMessage = backendError || `Errore Server (${error.status}): ${error.message}`;
                    }
                } else {
                    console.warn('Logging API failed');
                }
            }

            // Don't show toast for form endpoints - they handle errors in their UI
            const skipToastUrls = [
                '/api/events/book',           // Event Booking Modal
                '/api/custom-tours',          // Custom Tour Modal
                '/api/contact',               // Contact Form
                '/api/membership-requests',   // Membership Form
                '/api/course-requests'        // Courses Form
            ];
            const shouldShowToast = !skipToastUrls.some(url => req.url.includes(url));

            if (shouldShowToast) {
                notificationService.showError(errorMessage);
            }

            return throwError(() => error);
        })
    );
};
